<div class="container-fluid-modal">
   
     <form #cat="ngForm" (ngSubmit)="cat.form.valid && submitForm(cat.value)" novalidate>

    <div class="add col-lg-12">
      <div class="ModalHeader">
        <h4 mat-dialog-title>{{title}} User Roles</h4>
        <div class="headerButton">
          <button *ngIf="addPermission || editPermission" class="btn btn-success" type="submit"><i aria-hidden="true" class="fa fa-floppy-o"></i> Save
          </button>
          <button (click)="close()" class="btn btn-warning" matDialogClose type="button"><i
            aria-hidden="true" class="fa fa-times"></i> Cancel
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <div class="card">
          <div class="card-body">
            <div class="form-group col-lg-12">
              <div class="row col-lg-12">
                <label class="col-lg-2 labelRequired">User Roles Name: </label>
                <input class="col-lg-2" name="name"type="text" [(ngModel)]="formData.name" 
                  #name="ngModel"required="required"
                        required [ngClass]="{'has-danger': cat?.submitted  && name?.invalid }">
                <div *ngIf="cat?.submitted  && name?.invalid" >
                <div [hidden]="!name.errors.required" class="formError"> * User Roles Name is required</div>
                </div>

              </div>
              <div class="row col-lg-12">
                <mat-tab-group animationDuration="0ms" class="col-lg-12">
                  <mat-tab label="Dashboard">
                    <table class="table col-lg-12">
                      <tbody>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Total Orders </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="dashboard.total_orders" type="checkbox" value="1" [(ngModel)]="formData.dashboard.total_orders">&nbsp;View
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Available Stock </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="dashboard.available_stock" type="checkbox" value="1" [(ngModel)]="formData.dashboard.available_stock">&nbsp;View
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Total Consumed</h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="dashboard.total_consumed" type="checkbox" value="1" [(ngModel)]="formData.dashboard.total_consumed">&nbsp;View
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Pending </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="dashboard.pending" type="checkbox" value="1" [(ngModel)]="formData.dashboard.pending">&nbsp;View
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Today's Stock </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="dashboard.today_stock" type="checkbox" value="1" [(ngModel)]="formData.dashboard.today_stock" >&nbsp;View
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Notification</h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="dashboard.notification" type="checkbox" value="1" [(ngModel)]="formData.dashboard.notification">&nbsp;View
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Implant Categories </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="dashboard.implant_categories" type="checkbox" value="1" [(ngModel)]="formData.dashboard.implant_categories">&nbsp;View
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Products Used </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="dashboard.products_used" type="checkbox" value="1" [(ngModel)]="formData.dashboard.products_used">&nbsp;View
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Order Vs Stock </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="dashboard.order_stock" type="checkbox" value="1" [(ngModel)]="formData.dashboard.order_stock">&nbsp;View
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> City </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="dashboard.city" type="checkbox" value="1" [(ngModel)]="formData.dashboard.city">&nbsp;View
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </mat-tab>
                  <mat-tab label="Purchase Order">
                    <table class="table">
                      <tbody style="height:auto;">
                      <tr class="row col-lg-12">
                        <td class="col-lg-2">
                          <h6> Sales Order </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="purchase_order.view" type="checkbox" value="1" [(ngModel)]="formData.purchase_order.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="purchase_order.add" type="checkbox" value="1" [(ngModel)]="formData.purchase_order.add">&nbsp;Add
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="purchase_order.edit" type="checkbox" value="1" [(ngModel)]="formData.purchase_order.edit">&nbsp;Edit
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="purchase_order.delete" type="checkbox" value="1" [(ngModel)]="formData.purchase_order.delete">&nbsp;Delete
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="purchase_order.approval" type="checkbox" value="1" [(ngModel)]="formData.purchase_order.approval">&nbsp;Approval
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </mat-tab>
                  <mat-tab label="Invoice">
                    <table class="table">
                      <tbody style="height:auto;">
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Invoice </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="invoice.view" type="checkbox" value="1" [(ngModel)]="formData.invoice.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="invoice.add" type="checkbox" value="1" [(ngModel)]="formData.invoice.add">&nbsp;Add
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="invoice.edit" type="checkbox" value="1" [(ngModel)]="formData.invoice.edit">&nbsp;Details / Print
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="invoice.delete" type="checkbox" value="1" [(ngModel)]="formData.invoice.delete">&nbsp;Delete
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </mat-tab>
                  <mat-tab label="Stocks">
                    <table class="table">
                      <tbody style="height:auto;">
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Stock </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="stock.view" type="checkbox" value="1" [(ngModel)]="formData.stock.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="stock.search" type="checkbox" value="1" [(ngModel)]="formData.stock.search">&nbsp;Search
                        </td>i

                      </tr>
                      </tbody>
                    </table>
                  </mat-tab>
                  <mat-tab label="Tracking">
                    <table class="table">
                      <tbody style="height:auto;">
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6>Active Implants</h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="active_implants.view" type="checkbox" value="1" [(ngModel)]="formData.active_implants.view">&nbsp;View
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6>Accepted Implants</h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="accepted_implants.view" type="checkbox" value="1" [(ngModel)]="formData.accepted_implants.view" >&nbsp;View
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6>Rejected Implants</h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="rejected_implants.view" type="checkbox" value="1" [(ngModel)]="formData.rejected_implants.view">&nbsp;View
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6>Missing Implants</h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="missing_implants.view" type="checkbox" value="1" [(ngModel)]="formData.missing_implants.view">&nbsp;View
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </mat-tab>
                  <mat-tab label="More">
                    <table class="table">
                      <tbody>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Body Parts </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.body_parts.view" type="checkbox" value="1" [(ngModel)]="formData.more.body_parts.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.body_parts.add" type="checkbox" value="1" [(ngModel)]="formData.more.body_parts.add">&nbsp;Add
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.body_parts.edit" type="checkbox" value="1" [(ngModel)]="formData.more.body_parts.edit">&nbsp;Edit
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.body_parts.delete" type="checkbox" value="1" [(ngModel)]="formData.more.body_parts.delete">&nbsp;Delete
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Implants </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.implants.view" type="checkbox" value="1" [(ngModel)]="formData.more.implants.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.implants.add" type="checkbox" value="1" [(ngModel)]="formData.more.implants.add">&nbsp;Add
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.implants.edit" type="checkbox" value="1" [(ngModel)]="formData.more.implants.edit">&nbsp;Edit
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.implants.delete" type="checkbox" value="1" [(ngModel)]="formData.more.implants.delete">&nbsp;Delete
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Products Categories </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.products_categories.view" type="checkbox"
                                 value="1" [(ngModel)]="formData.more.products_categories.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.products_categories.add" type="checkbox"
                                 value="1" [(ngModel)]="formData.more.products_categories.add">&nbsp;Add
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.products_categories.edit" type="checkbox"
                                 value="1" [(ngModel)]="formData.more.products_categories.edit">&nbsp;Edit
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.products_categories.delete" type="checkbox"
                                 value="1" [(ngModel)]="formData.more.products_categories.delete">&nbsp;Delete
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Products </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.products.view" type="checkbox" value="1" [(ngModel)]="formData.more.products.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.products.add" type="checkbox" value="1" [(ngModel)]="formData.more.products.add">&nbsp;Add
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.products.edit" type="checkbox" value="1" [(ngModel)]="formData.more.products.edit">&nbsp;Edit
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.products.delete" type="checkbox" value="1" [(ngModel)]="formData.more.products.delete">&nbsp;Delete
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Regions </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.regions.view" type="checkbox" value="1" [(ngModel)]="formData.more.regions.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.regions.add" type="checkbox" value="1" [(ngModel)]="formData.more.regions.add">&nbsp;Add
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.regions.edit" type="checkbox" value="1" [(ngModel)]="formData.more.regions.edit">&nbsp;Edit
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.regions.delete" type="checkbox" value="1" [(ngModel)]="formData.more.regions.delete">&nbsp;Delete
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Countries </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.countries.view" type="checkbox" value="1" [(ngModel)]="formData.more.countries.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.countries.add" type="checkbox" value="1" [(ngModel)]="formData.more.countries.add">&nbsp;Add
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.countries.edit" type="checkbox" value="1" [(ngModel)]="formData.more.countries.edit">&nbsp;Edit
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.countries.delete" type="checkbox" value="1" [(ngModel)]="formData.more.countries.delete">&nbsp;Delete
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Cities </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.cities.view" type="checkbox" value="1" [(ngModel)]="formData.more.cities.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.cities.add" type="checkbox" value="1" [(ngModel)]="formData.more.cities.add">&nbsp;Add
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.cities.edit" type="checkbox" value="1" [(ngModel)]="formData.more.cities.edit">&nbsp;Edit
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.cities.delete" type="checkbox" value="1" [(ngModel)]="formData.more.cities.delete">&nbsp;Delete
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Stores </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.stores.view" type="checkbox" value="1" [(ngModel)]="formData.more.stores.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.stores.add" type="checkbox" value="1" [(ngModel)]="formData.more.stores.add">&nbsp;Add
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.stores.edit" type="checkbox" value="1" [(ngModel)]="formData.more.stores.edit">&nbsp;Edit
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.stores.delete" type="checkbox" value="1" [(ngModel)]="formData.more.stores.delete">&nbsp;Delete
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Antennas </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.antennas.view" type="checkbox" value="1" [(ngModel)]="formData.more.antennas.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.antennas.add" type="checkbox" value="1" [(ngModel)]="formData.more.antennas.add">&nbsp;Add
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.antennas.edit" type="checkbox" value="1" [(ngModel)]="formData.more.antennas.edit">&nbsp;Edit
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.antennas.delete" type="checkbox" value="1" [(ngModel)]="formData.more.antennas.delete">&nbsp;Delete
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Users </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.users.view" type="checkbox" value="1" [(ngModel)]="formData.more.users.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.users.add" type="checkbox" value="1" [(ngModel)]="formData.more.users.add">&nbsp;Add
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.users.edit" type="checkbox" value="1" [(ngModel)]="formData.more.users.edit">&nbsp;Edit
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.users.delete" type="checkbox" value="1" [(ngModel)]="formData.more.users.delete">&nbsp;Delete
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Users Roles</h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.users_roles.view" type="checkbox" value="1" [(ngModel)]="formData.more.users_roles.view">&nbsp;View
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.users_roles.add" type="checkbox" value="1" [(ngModel)]="formData.more.users_roles.add">&nbsp;Add
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.users_roles.edit" type="checkbox" value="1" [(ngModel)]="formData.more.users_roles.edit">&nbsp;Edit
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="more.users_roles.delete" type="checkbox" value="1" [(ngModel)]="formData.more.users_roles.delete">&nbsp;Delete
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </mat-tab>
                  <mat-tab label="Bulk Uploads">
                    <table class="table">
                      <tbody>
                        <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Body Parts </h6>
                        </td>
                        <td class="col-lg-2">
                           <input class="form-control col-md-1" name="bulk_upload.body_parts.upload" type="checkbox" value="1" [(ngModel)]="formData.bulk_upload.body_parts.upload">&nbsp;Upload
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Implants </h6>
                        </td>
                        <td class="col-lg-2">
                           <input class="form-control col-md-1" name="bulk_upload.implants.upload" type="checkbox" value="1" [(ngModel)]="formData.bulk_upload.implants.upload">&nbsp;Upload
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Product Categories </h6>
                        </td>
                        <td class="col-lg-2">
                           <input class="form-control col-md-1" name="bulk_upload.products_categories.upload" type="checkbox" value="1" [(ngModel)]="formData.bulk_upload.products_categories.upload">&nbsp;Upload
                        </td>
                      </tr>
                       <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Products </h6>
                        </td>
                        <td class="col-lg-2">
                           <input class="form-control col-md-1" name="bulk_upload.products.upload" type="checkbox" value="1" [(ngModel)]="formData.bulk_upload.products.upload">&nbsp;Upload
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Purchase Order </h6>
                        </td>
                        <td class="col-lg-2">
                           <input class="form-control col-md-1" name="bulk_upload.purchase_order.upload" type="checkbox" value="1" [(ngModel)]="formData.bulk_upload.purchase_order.upload">&nbsp;Upload
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Invoice </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="bulk_upload.invoice.upload" type="checkbox" value="1" [(ngModel)]="formData.bulk_upload.invoice.upload">&nbsp;Upload
                        </td>
                      </tr>
                      <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> RFID Manual </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="bulk_upload.rfid1.upload" type="checkbox" value="1" [(ngModel)]="formData.bulk_upload.rfid1.upload">&nbsp;Upload
                        </td>
                      </tr>
<tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> RFID Mobile </h6>
                        </td>
                        <td class="col-lg-2">
                          <input class="form-control col-md-1" name="bulk_upload.rfid2.upload" type="checkbox" value="1" [(ngModel)]="formData.bulk_upload.rfid2.upload">&nbsp;Upload
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </mat-tab> 
             <mat-tab label="Setting">
                    <table class="table">
                      <tbody>
                        <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Android Setting </h6>
                        </td>
                        <td class="col-lg-2">
                           <input class="form-control col-md-1" name="setting.android.view" type="checkbox" value="1" [(ngModel)]="formData.setting.android.view">&nbsp;View 
                        </td>
                      </tr>
                       <tr class="row col-lg-12">
                        <td class="col-lg-4">
                          <h6> Report Setting </h6>
                        </td>
                        <td class="col-lg-2">
                           <input class="form-control col-md-1" name="setting.reports.update" type="checkbox" value="1" [(ngModel)]="formData.setting.reports.update">&nbsp;Update;
                        </td>
                           <td class="col-lg-2">
                           <input class="form-control col-md-1" name="setting.reports.view" type="checkbox" value="1" [(ngModel)]="formData.setting.reports.view">&nbsp;View;
                        </td>

                      </tr>
                     
                    </tbody>
                  </table>
             </mat-tab>


                </mat-tab-group>
              </div>
            </div>
          </div>
        </div>
      </mat-dialog-content>
    </div>
  </form>
</div>
